import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TertiaryButton from "../../../../../Buttons/TertiaryButton/TertiaryButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SubmittedComchecksTable from "../SubmittedComchecksTable/SubmittedComchecksTable";

export default function ComchecksStepFour({
  activeLoad,
  carrier,
  stagedComchecksArray,
  setStagedComchecksArray,
  setStep,
  setComcheckToEdit,
  handleDeleteStagedComcheck
}) {
  const handleAddNew = () => {
    setComcheckToEdit({});
    setStagedComchecksArray([]);
    setStep(1);
  };

  return (
    <Box>
      <Box className="Accessorial-modal-form-row">
        <Typography variant="subhead2" color="black_solid.60">
          Payable to
        </Typography>
        <Typography variant="subhead1" color="black_solid.80" sx={{ marginTop: "6px" }}>
          {carrier.name}
        </Typography>
      </Box>
      <Box sx={{ margin: "30px 0" }}>
        <SubmittedComchecksTable
          activeLoad={activeLoad}
          stagedComchecksArray={stagedComchecksArray}
          setStagedComchecksArray={setStagedComchecksArray}
          setComcheckToEdit={setComcheckToEdit}
          setStep={setStep}
          handleDeleteStagedComcheck={handleDeleteStagedComcheck}
        />
      </Box>
      <Box sx={{ display: "flex", marginTop: "50px" }}>
        <Box sx={{ marginLeft: "auto" }}>
          <TertiaryButton
            label="Add Comcheck"
            onClick={handleAddNew}
            startIcon={AddCircleIcon}
          />
        </Box>
      </Box>
    </Box>
  );
}

ComchecksStepFour.propTypes = {
  activeLoad: PropTypes.object.isRequired,
  carrier: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  setStep: PropTypes.func,
  stagedComchecksArray: PropTypes.array.isRequired,
  setStagedComchecksArray: PropTypes.func.isRequired,
  setComcheckToEdit: PropTypes.func,
  handleDeleteStagedComcheck: PropTypes.func
};